<div class="lastscan container-fluid">
  <div class="row" *ngIf="cameravideo">
    <div class="col-4 center" (click)="openplayer(cameraList[0])" *ngIf="cameravideo[0]"><video src="{{cameravideo[0]}}" crossorigin="anonymous" loop autoplay></video>
    </div>
    <div class="col-4 center" (click)="openplayer(cameraList[1])" *ngIf="cameravideo[1]">
        <video src="{{cameravideo[1]}}" crossorigin="anonymous" loop autoplay></video>
    </div>
    <div class="col-4 center" (click)="openplayer(cameraList[2])" *ngIf="cameravideo[2]">
        <div class="info">
            <span *ngIf="immat">IMMAT : {{immat}}</span>
            <span *ngIf="tchekCreatedAt">DATE : {{tchekCreatedAt}}</span>
        </div>
      <video src="{{cameravideo[2]}}" crossorigin="anonymous" loop autoplay></video>
    </div>
  </div>
  <div class="row" *ngIf="cameravideo">
    <div class="col-4 center" (click)="openplayer(cameraList[3])" *ngIf="cameravideo[3]"><video src="{{cameravideo[3]}}" crossorigin="anonymous" loop autoplay></video>
    </div>
    <div class="col-4 center" (click)="openplayer(cameraList[4])" *ngIf="cameravideo[4]"><video src="{{cameravideo[4]}}" crossorigin="anonymous" loop autoplay></video>
    </div>
    <div class="col-4 center" (click)="openplayer(cameraList[5])" *ngIf="cameravideo[5]"><video src="{{cameravideo[5]}}" crossorigin="anonymous" loop autoplay></video>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/tchek-last-scan/tchek-last-scan.component.html